import { useLocation } from "react-router-dom";
import { Footer } from "../../components";
import MainLayout from "../../layouts/main-layout/main-layout";
const RedirectPromos = () => {

  const location = useLocation();
  const param = location.search.substring();

  window.location.href = 'https://mx.claropay.com/promociones/regalosmbtelcel.html' + param;

  return (
    <>
      <MainLayout />
      <Footer />
    </>
  );
}

export default RedirectPromos;